import noTransactions from 'src/assets/images/plugs/noTransactions.webp';
import { useTranslation } from 'react-i18next';

export const NotFoundTransactions = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-6 pt-5">
      <p className="font-bold text-lg text-wthap_basic_not_found text-center">
        {t('transactionTable.notFoundTransactionsText')}
      </p>
      <img
        src={noTransactions}
        alt="no transactions image"
        width="260px"
        height="230px"
        className="w-[260px]"
      />
    </div>
  );
};
